import { RegistryTypes } from 'Portainer/models/registryTypes';

angular.module('portainer.registrymanagement').factory('RegistryServiceSelector', [
  '$q',
  'RegistryV2Service',
  'RegistryGitlabService',
  'RegistryEcrService',
  function RegistryServiceSelector($q, RegistryV2Service, RegistryGitlabService, RegistryEcrService) {
    'use strict';
    const service = {
      ping,
      repositories,
      getRepositoriesDetails,
      tag,
      tags,
      getTagsDetails,
      addTag,
      retagWithProgress,
      shortTagsWithProgress,
      deleteTagsWithProgress,
      deleteManifest,
      deleteRepository,
      batchDeleteTags,
    };

    function ping(registry, forceNewConfig) {
      let service = RegistryV2Service;
      return service.ping(registry, forceNewConfig);
    }

    function repositories(registry) {
      let service = RegistryV2Service;
      if (registry.Type === RegistryTypes.GITLAB) {
        service = RegistryGitlabService;
      }
      return service.repositories(registry);
    }

    function getRepositoriesDetails(registry, repositories) {
      let service = RegistryV2Service;
      return service.getRepositoriesDetails(registry, repositories);
    }

    function tags(registry, repository) {
      let service = RegistryV2Service;
      return service.tags(registry, repository);
    }

    function getTagsDetails(registry, repository, tags) {
      let service = RegistryV2Service;
      return service.getTagsDetails(registry, repository, tags);
    }

    function tag(registry, repository, tag) {
      let service = RegistryV2Service;
      return service.tag(registry, repository, tag);
    }

    function addTag(registry, repository, tag, manifest) {
      let service = RegistryV2Service;
      return service.addTag(registry, repository, tag, manifest);
    }

    function deleteManifest(registry, repository, digest) {
      let service = RegistryV2Service;
      return service.deleteManifest(registry, repository, digest);
    }

    function shortTagsWithProgress(registry, repository, tagsList) {
      let service = RegistryV2Service;
      return service.shortTagsWithProgress(registry, repository, tagsList);
    }

    function deleteTagsWithProgress(registry, repository, modifiedDigests, impactedTags) {
      let service = RegistryV2Service;
      return service.deleteTagsWithProgress(registry, repository, modifiedDigests, impactedTags);
    }

    function retagWithProgress(registry, repository, modifiedTags, modifiedDigests, impactedTags) {
      let service = RegistryV2Service;
      if (registry.Type === RegistryTypes.ECR) {
        service = RegistryEcrService;
      }
      return service.retagWithProgress(registry, repository, modifiedTags, modifiedDigests, impactedTags);
    }

    function batchDeleteTags(params, data) {
      // Only for ECR
      const service = RegistryEcrService;
      return service.batchDeleteTags(params, data);
    }

    function deleteRepository(registry, repository) {
      // Only for ECR
      const service = RegistryEcrService;
      return service.deleteRepository(registry, repository);
    }

    return service;
  },
]);
